import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION9: PdfComponent = {
  type: 'section',
  id: 's1s9',
  title: '9. Key Data Protection Representatives',
  content: [
    {
      type: 'bulletList',
      id: 's3s3bullets',
      bulletType: 'number',
      content: [
        {
          copy: {
            type: 'altText',
            id: '9kdpr',
            content: [
              'The holders of the following roles shall be the initial ',
              'Key Data Protection Representatives',
              ' of each party for the purposes of this Agreement:',
            ],
            boldFirst: false,
          },
          sublist: {
            bulletType: 'dot',
            content: [
              {
                copy: {
                  type: 'altText',
                  id: '9jc1',
                  content: ['JC1', ' - Richard Fleeman (CEO / Co-founder)'],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: '9jc2',
                  content: ['JC2', ' - Robert Gallagher (COO / Co-founder)'],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: '9jc3',
                  content: ['JC3', ' - {{SIGNEE}}'],
                },
              },
            ],
          },
        },
        {
          copy: 'Either party may replace or appoint an additional Key Data Protection Representative by giving written notice to the other party.',
        },
        {
          copy: 'The parties shall procure that:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'the Key Data Protection Representatives shall liaise with one another, co-operate, and take joint decisions where required regarding any data protection issues related to this Agreement; and',
              },
              {
                copy: 'any disputes arising between the parties in relation to data protection shall be dealt with promptly and in accordance with clause 20 (Dispute Resolution) of this Agreement.',
              },
            ],
          },
        },
      ],
      prefix: '9',
    },
  ],
};
